import dayjs from "dayjs"
import * as React from "react"
import styled from "styled-components"
import H3 from "../typography/H3"

interface Props {
  onSelectDate?: (value: any) => void
  defualtValue?: string
  value?: string
  disabled?: boolean
  minDate?: string
  useMinDate?: boolean
}

const DatePickerContainer = styled.div`
  position: relative;
`

const InputStyle = styled(H3)<{ isDisabled?: boolean }>`
  background: none;
  border: none;
  text-align: left;
  text-transform: uppercase;
  cursor: pointer;
  border-bottom: 3px solid #616161;
  color: ${(props) => (props.isDisabled ? props.theme.colors.greyDisabled : props.theme.colors.greyDark)};
  padding-bottom: 6px;

  &::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
`

const DatePicker: React.FunctionComponent<Props> = ({
  onSelectDate,
  defualtValue,
  value,
  disabled,
  minDate,
  useMinDate = false,
}) => {
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newDate = event.target.value
    console.log(newDate)
    onSelectDate && onSelectDate(newDate)
  }

  return (
    <DatePickerContainer>
      <InputStyle
        as="input"
        type="date"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e)}
        defaultValue={defualtValue}
        value={value}
        disabled={disabled}
        isDisabled={disabled}
        min={useMinDate ? (minDate ?? dayjs().format("YYYY-MM-DD")) : undefined}
      />
    </DatePickerContainer>
  )
}

export default DatePicker
